<template>
  <div v-if="site">
    <div v-if="site === 'bitsems'">
      <BitsEMS></BitsEMS>
    </div>
    <div v-else>
      <TemplateOne></TemplateOne>
    </div>
  </div>
</template>

<script>
import TemplateOne from "@/components/SchoolWebsite/Templates/Template1/Template1.vue";
import BitsEMS from "@/components/SchoolWebsite/BitsEMS.vue";
export default {
  components: {
    TemplateOne,
    BitsEMS,
  },
  data: () => ({
    site: null,
  }),
  created() {
    if (window.location.hostname.includes("bitsems.co.za")) {
      this.site = "bitsems";
    } else {
      this.site = "school";
    }
  },
  mounted() {
    if (window.location.hostname.includes("bitsems.co.za")) {
      this.site = "bitsems";
    } else {
      this.site = "school";
    }
  },
};
</script>
